import uiRouter, {StateProvider} from "@uirouter/angularjs";
import * as angular from "angular";
import "angular-animate";
import "angular-feature-flags";
import "angular-moment";
import "angular-monash";
import "angular-monash/dist/angular-monash.css";
import "angular-scroll";
import "angularjs-scroll-glue";
import "angular-ui-bootstrap";
import "angular-ui-scrollpoint";
import "angularjs-toaster";
import "angularjs-toaster/toaster.css";
import "checklist-model";
import "cleave.js/dist/cleave-angular";
import "ng-mask";
import "ng-tags-input";
import "ng-tags-input/build/ng-tags-input.css";
import "ng-tags-input/build/ng-tags-input.bootstrap.css";
import "ngRipple/angular-ripple";
import {AdminModule} from "./admin/admin.module";
import {StaffModule} from "./staff/staff.module";
import {StudentModule} from "./student/student.module";
import {ConfigModule} from "./shared/config/config.module";
import {ReferenceDataModule} from "./shared/reference-data/reference-data.module";
import {ReferenceData} from "./shared/reference-data/reference-data.service";
import {FilterModule} from "./shared/filter/filter.module";
import "../common/main.less";

export default angular
    .module("app", [
        "ngAnimate",
        "feature-flags",
        "angularMoment",
        "angularRipple",
        "checklist-model",
        "cleave.js",
        "ui.bootstrap",
        "ui.scrollpoint",
        "ngMessages",
        "ngSanitize",
        "ngFileUpload",
        "angular-monash",
        "toaster",
        "ngMask",
        "ngTagsInput",
        "luegg.directives", // angular-scroll-glue
        "duScroll",
        uiRouter,
        ReferenceDataModule,
        ConfigModule,
        FilterModule,
        AdminModule,
        StaffModule,
        StudentModule
    ])

    .config(($stateProvider: StateProvider, $urlServiceProvider) => {
        $urlServiceProvider.rules.otherwise("/not-found");

        $stateProvider
            .state("app", {
                abstract: true,
                template: "<ui-view/>",
                resolve: {
                    currentUser: (authService) => authService.me(),
                    referenceDataInit: (referenceData: ReferenceData) => {
                        referenceData.init();
                    }
                }
            })

            .state("notFound", {
                url: "/not-found",
                template: require("./404.html")
            })

            .state("invalidStatus", {
                parent: "app",
                url: "/invalid-status",
                component: "invalidStatus",
                params: {
                    message: null
                },
                resolve: {
                    message: ($stateParams) => $stateParams.message
                }
            });
    });



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/app.ts